module.exports = __webpack_public_path__ + "static/media/wxwork-error.101a98c7.png";